import { Grid, IconButton } from '@mui/material'
import CarePlanTaskEditor from './CarePlanTaskEditor'

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import CloseIcon from '@mui/icons-material/Close'
import type { FC } from 'react'
import { memo } from 'react'
import { CarePlanModalTask } from './useCarePlanModal'
import type { PatientUser } from '~/shared/types'

interface CarePlanTaskEditorRowProps {
  i: number
  patient: PatientUser
  task: CarePlanModalTask
  disabledEdit: boolean
  disabledRemove: boolean
  onChange: (i: number, value: Partial<CarePlanModalTask>) => void
  onRemove: (i: number) => void
}

/**
 * A single row in the care plan modal using snake_case CarePlanModalTask.
 */
const CarePlanTaskEditorRow: FC<CarePlanTaskEditorRowProps> = props => {
  const { i, patient, task, disabledEdit, disabledRemove, onChange, onRemove } = props
  const TaskIcon = task.is_complete ? CheckCircleOutlineIcon : CloseIcon

  const handleChange = (updatedTask: CarePlanModalTask) => {
    onChange(i, updatedTask)
  }

  return (
    <Grid container>
      <Grid size={11}>
        <CarePlanTaskEditor
          disabled={disabledEdit}
          task={task}
          onChange={handleChange}
          patient={patient}
        />
      </Grid>
      <Grid size={1}>
        <IconButton disabled={disabledRemove} onClick={() => onRemove(i)}>
          <TaskIcon />
        </IconButton>
      </Grid>
    </Grid>
  )
}

export default memo(CarePlanTaskEditorRow)
